/* eslint-disable no-unused-vars */
import * as React from "react";
import { IconSvgProps } from "@/types";

export const Logo: React.FC<IconSvgProps> = ({
	size = 36,
	width,
	height,
	...props
}) => (
	<svg
		fill="none"
		height={size || height}
		viewBox="0 0 32 32"
		width={size || width}
		{...props}
	>
		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="Group" fill="currentColor" fillRule="nonzero">
				<g id="O">
					<path d="M7.436,18.824 C5.02666667,18.824 3.185,18.265 1.911,17.147 C0.637,16.029 0,14.378 0,12.194 L0,6.63 C0,4.446 0.637,2.795 1.911,1.677 C3.185,0.559 5.02666667,0 7.436,0 C9.84533333,0 11.687,0.559 12.961,1.677 C14.235,2.795 14.872,4.446 14.872,6.63 L14.872,12.194 C14.872,14.378 14.235,16.029 12.961,17.147 C11.687,18.265 9.84533333,18.824 7.436,18.824 Z M7.436,15.964 C8.64933333,15.964 9.581,15.639 10.231,14.989 C10.881,14.339 11.206,13.4073333 11.206,12.194 L11.206,6.63 C11.206,5.41666667 10.881,4.485 10.231,3.835 C9.581,3.185 8.64933333,2.86 7.436,2.86 C6.22266667,2.86 5.291,3.185 4.641,3.835 C3.991,4.485 3.666,5.41666667 3.666,6.63 L3.666,12.194 C3.666,13.4073333 3.991,14.339 4.641,14.989 C5.291,15.639 6.22266667,15.964 7.436,15.964 Z" id="Shape"></path>
				</g>
				<g id="3" transform="translate(16.02, 10.902)">
					<path d="M5.13,5.76 L5.13,5.688 C6.084,5.418 6.858,4.536 6.858,3.042 C6.858,1.044 5.634,0 3.546,0 C1.62,0 0.432,1.188 0.234,2.664 L1.836,2.898 C1.962,2.088 2.466,1.44 3.51,1.44 C4.68,1.44 5.202,2.142 5.202,3.168 C5.202,4.518 4.608,5.166 3.168,5.166 L2.412,5.166 L2.412,6.57 L3.168,6.57 C4.788,6.57 5.58,7.056 5.58,8.352 C5.58,9.612 5.004,10.332 3.6,10.332 C2.466,10.332 1.818,9.63 1.494,9.018 L1.77635684e-15,9.828 C0.468,10.836 1.62,11.754 3.402,11.754 C5.796,11.754 7.2,10.512 7.2,8.28 C7.2,6.534 6.192,5.886 5.13,5.76 Z" id="Path"></path>
				</g>
			</g>
		</g>
	</svg>
);

export const TranslateIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 0 24 24"
			width={size || width}
			{...props}
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const TwitterIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 0 24 24"
			width={size || width}
			{...props}
		>
			<path
				d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const GithubIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 0 24 24"
			width={size || width}
			{...props}
		>
			<path
				clipRule="evenodd"
				d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	);
};

export const GoogleIcon: React.FC<IconSvgProps> = ({
	size = 16,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 0 16 16"
			width={size || width}
			fill="currentColor"
			{...props}
		>

			<path fill="currentColor" d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />

		</svg>
	);
};

export const MoonFilledIcon = ({
	size = 24,
	width,
	height,
	...props
}: IconSvgProps) => (
	<svg
		aria-hidden="true"
		focusable="false"
		height={size || height}
		role="presentation"
		viewBox="0 0 24 24"
		width={size || width}
		{...props}
	>
		<path
			d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
			fill="currentColor"
		/>
	</svg>
);

export const SunFilledIcon = ({
	size = 24,
	width,
	height,
	...props
}: IconSvgProps) => (
	<svg
		aria-hidden="true"
		focusable="false"
		height={size || height}
		role="presentation"
		viewBox="0 0 24 24"
		width={size || width}
		{...props}
	>
		<g fill="currentColor">
			<path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
			<path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
		</g>
	</svg>
);

export const HeartFilledIcon = ({
	size = 24,
	width,
	height,
	...props
}: IconSvgProps) => (
	<svg
		aria-hidden="true"
		focusable="false"
		height={size || height}
		role="presentation"
		viewBox="0 0 24 24"
		width={size || width}
		{...props}
	>
		<path
			d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
			fill="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
		/>
	</svg>
);

export const SearchIcon = (props: IconSvgProps) => (
	<svg
		aria-hidden="true"
		fill="none"
		focusable="false"
		height="1em"
		role="presentation"
		viewBox="0 0 24 24"
		width="1em"
		{...props}
	>
		<path
			d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
		/>
		<path
			d="M22 22L20 20"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
		/>
	</svg>
);

export const NextUILogo: React.FC<IconSvgProps> = (props) => {
	const { width, height = 40 } = props;

	return (
		<svg
			fill="none"
			height={height}
			viewBox="0 0 161 32"
			width={width}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>

			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Group" fill="currentColor">
					<text id="3" fontFamily="KohinoorBangla-Medium, Kohinoor Bangla" fontSize="7" fontWeight="400">
						<tspan x="7" y="13">3</tspan>
					</text>
					<text id="O" fontFamily="Krungthep" fontSize="12" fontWeight="bold">
						<tspan x="0" y="12">O</tspan>
					</text>
				</g>
			</g>

		</svg>
	);
};

export const FacebookIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 0 24 24"
			width={size || width}
			{...props}
		>
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="facebook" transform="translate(0, 1)" fill="currentColor" fillRule="nonzero">
					<path d="M19,10.5581802 C19,5.2792151 14.7469066,1 9.50118735,1 C4.25309336,1.00118735 0,5.2792151 0,10.5593676 C0,15.3289589 3.47419073,19.2828396 8.01462317,20 L8.01462317,13.3211474 L5.60429946,13.3211474 L5.60429946,10.5593676 L8.01699788,10.5593676 L8.01699788,8.45181852 C8.01699788,6.05693038 9.43588301,4.73422072 11.6051744,4.73422072 C12.6452943,4.73422072 13.731721,4.92063492 13.731721,4.92063492 L13.731721,7.27159105 L12.5336833,7.27159105 C11.3546432,7.27159105 10.9865642,8.00893638 10.9865642,8.76527934 L10.9865642,10.5581802 L13.62011,10.5581802 L13.1997875,13.31996 L10.9853768,13.31996 L10.9853768,19.9988126 C15.5258093,19.2816523 19,15.3277715 19,10.5581802 Z" id="Path"></path>
				</g>
			</g>
		</svg>
	);
};

export const EmailIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 -960 960 960"
			width={size || width}
			{...props}
		>
			<g fill="currentColor" >
				<path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
			</g>
		</svg>
	);
};

export const PassKeyIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 -960 960 960"
			width={size || width}
			{...props}
		>
			<g fill="currentColor" >
				<path d="M120-160v-112q0-34 17.5-62.5T184-378q62-31 126-46.5T440-440q20 0 40 1.5t40 4.5q-4 58 21 109.5t73 84.5v80H120ZM760-40l-60-60v-186q-44-13-72-49.5T600-420q0-58 41-99t99-41q58 0 99 41t41 99q0 45-25.5 80T790-290l50 50-60 60 60 60-80 80ZM440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm300 80q17 0 28.5-11.5T780-440q0-17-11.5-28.5T740-480q-17 0-28.5 11.5T700-440q0 17 11.5 28.5T740-400Z" />
			</g>
		</svg>
	);
};

export const EditIcon = (props: IconSvgProps) => (
	<svg
		aria-hidden="true"
		fill="none"
		focusable="false"
		height="1em"
		role="presentation"
		viewBox="0 0 20 20"
		width="1em"
		{...props}
	>
		<path
			d="M11.05 3.00002L4.20835 10.2417C3.95002 10.5167 3.70002 11.0584 3.65002 11.4334L3.34169 14.1334C3.23335 15.1084 3.93335 15.775 4.90002 15.6084L7.58335 15.15C7.95835 15.0834 8.48335 14.8084 8.74168 14.525L15.5834 7.28335C16.7667 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2334 1.75002 11.05 3.00002Z"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
		/>
		<path
			d="M9.90833 4.20831C10.2667 6.50831 12.1333 8.26665 14.45 8.49998"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
		/>
		<path
			d="M2.5 18.3333H17.5"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
		/>
	</svg>
);

export const DeleteIcon = (props: IconSvgProps) => (
	<svg
		aria-hidden="true"
		fill="none"
		focusable="false"
		height="1em"
		role="presentation"
		viewBox="0 0 20 20"
		width="1em"
		{...props}
	>
		<path d="m376-300 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 180q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520Zm-400 0v520-520Z" />
	</svg>
);

export const EyeSlashFilledIcon = (props: IconSvgProps) => (
	<svg
		aria-hidden="true"
		fill="none"
		focusable="false"
		height="1em"
		role="presentation"
		viewBox="0 0 24 24"
		width="1em"
		{...props}
	>
		<path
			d="M21.2714 9.17834C20.9814 8.71834 20.6714 8.28834 20.3514 7.88834C19.9814 7.41834 19.2814 7.37834 18.8614 7.79834L15.8614 10.7983C16.0814 11.4583 16.1214 12.2183 15.9214 13.0083C15.5714 14.4183 14.4314 15.5583 13.0214 15.9083C12.2314 16.1083 11.4714 16.0683 10.8114 15.8483C10.8114 15.8483 9.38141 17.2783 8.35141 18.3083C7.85141 18.8083 8.01141 19.6883 8.68141 19.9483C9.75141 20.3583 10.8614 20.5683 12.0014 20.5683C13.7814 20.5683 15.5114 20.0483 17.0914 19.0783C18.7014 18.0783 20.1514 16.6083 21.3214 14.7383C22.2714 13.2283 22.2214 10.6883 21.2714 9.17834Z"
			fill="currentColor"
		/>
		<path
			d="M14.0206 9.98062L9.98062 14.0206C9.47062 13.5006 9.14062 12.7806 9.14062 12.0006C9.14062 10.4306 10.4206 9.14062 12.0006 9.14062C12.7806 9.14062 13.5006 9.47062 14.0206 9.98062Z"
			fill="currentColor"
		/>
		<path
			d="M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z"
			fill="currentColor"
		/>
		<path
			d="M14.8581 11.9981C14.8581 13.5681 13.5781 14.8581 11.9981 14.8581C11.9381 14.8581 11.8881 14.8581 11.8281 14.8381L14.8381 11.8281C14.8581 11.8881 14.8581 11.9381 14.8581 11.9981Z"
			fill="currentColor"
		/>
		<path
			d="M21.7689 2.22891C21.4689 1.92891 20.9789 1.92891 20.6789 2.22891L2.22891 20.6889C1.92891 20.9889 1.92891 21.4789 2.22891 21.7789C2.37891 21.9189 2.56891 21.9989 2.76891 21.9989C2.96891 21.9989 3.15891 21.9189 3.30891 21.7689L21.7689 3.30891C22.0789 3.00891 22.0789 2.52891 21.7689 2.22891Z"
			fill="currentColor"
		/>
	</svg>
);

export const EyeFilledIcon = (props: IconSvgProps) => (
	<svg
		aria-hidden="true"
		fill="none"
		focusable="false"
		height="1em"
		role="presentation"
		viewBox="0 0 24 24"
		width="1em"
		{...props}
	>
		<path
			d="M21.25 9.14969C18.94 5.51969 15.56 3.42969 12 3.42969C10.22 3.42969 8.49 3.94969 6.91 4.91969C5.33 5.89969 3.91 7.32969 2.75 9.14969C1.75 10.7197 1.75 13.2697 2.75 14.8397C5.06 18.4797 8.44 20.5597 12 20.5597C13.78 20.5597 15.51 20.0397 17.09 19.0697C18.67 18.0897 20.09 16.6597 21.25 14.8397C22.25 13.2797 22.25 10.7197 21.25 9.14969ZM12 16.0397C9.76 16.0397 7.96 14.2297 7.96 11.9997C7.96 9.76969 9.76 7.95969 12 7.95969C14.24 7.95969 16.04 9.76969 16.04 11.9997C16.04 14.2297 14.24 16.0397 12 16.0397Z"
			fill="currentColor"
		/>
		<path
			d="M11.9984 9.14062C10.4284 9.14062 9.14844 10.4206 9.14844 12.0006C9.14844 13.5706 10.4284 14.8506 11.9984 14.8506C13.5684 14.8506 14.8584 13.5706 14.8584 12.0006C14.8584 10.4306 13.5684 9.14062 11.9984 9.14062Z"
			fill="currentColor"
		/>
	</svg>
);

export const ChevronDown: React.FC<IconSvgProps> = ({ fill, size, height, width, ...props }) => {
	return (
		<svg
			fill="none"
			height={size || height || 24}
			viewBox="0 0 24 24"
			width={size || width || 24}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="m19.92 8.95-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95"
				stroke={fill}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				strokeWidth={1.5}
			/>
		</svg>
	);
};

export const Niras = (props: IconSvgProps) => (
	<svg id="svg-niras" viewBox="0 0 520 170" fill="none">
		<path fill="#BA1223" stroke="none" d="M79.82,126.75,37.54,82.46H6v83.21H31.5l2.68-50.33,49.66,50.33h24.83V82.46H82.5ZM133.5,82.46H161v83.21H133.5Zm145.62,24.83c-1.34-21.47-24.83-25.5-43.62-26.17-15.43,0-51,1.34-51,1.34v83.21h24.83l4-66.43s10.07-.67,16.78-.67c10.74,0,18.12,4,18.79,10.74s-2,14.76-26.17,14.76v13.42l26.84,28.86h28.86L257,136.14c.67-.67,23.49-6.71,22.14-28.86m96-24.83H334.15s-4,6-17.45,32.88c-18.12-14.76-22.82-34.22-24.16-43.62h-.67v35.57a58.25,58.25,0,0,0,15.43,28.18C295.23,160.3,293.21,165,293.21,165h26.84l8.72-16.11h0a88.8,88.8,0,0,0,26.17,4.7V130.77a55.52,55.52,0,0,1-14.76-2.68l13.42-24.16,34.89,61.74h26.84S412,157.61,394.54,122c-15.43-33.55-19.46-39.59-19.46-39.59m93.28,28.86c-8.72-.67-13.42-2.68-13.42-6.71,0-5.37,6.71-7.38,20.8-7.38s32.88,2.68,32.88,2.68V80.44a311.54,311.54,0,0,0-42.28-2c-7.38,0-42.95,0-42.95,28.18,0,26.84,34.89,27.51,49.66,28.18,5.37,0,11.41,1.34,11.41,5.37.67,6.71-10.07,7.38-26.17,7.38a142.28,142.28,0,0,1-31.54-4v20.8S448.9,167,465.67,167c7.38,0,49,1.34,48.32-28.18.67-29.53-32.88-26.84-45.63-27.51M310,74.4c3.36-18.12,21.47-37.58,45.63-38.92V10C320.73,14,307.3,44.21,308,61.65c.67,4,.67,8.72,2,12.75Z"></path>
	</svg>
);

export const ChevronLeftIcon = (props: IconSvgProps) => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6" {...props}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
	</svg>
);

export const ChevronRightIcon = (props: IconSvgProps) => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6" {...props}>
		<path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
	</svg>
);

export const DiaIcon = (props: IconSvgProps) => (
	<svg {...props} width="32px" height="32px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="Дія-(Solid)" fillRule="nonzero">
				<path d="M12,24 C17.2584375,24 20.1816094,24 22.0908047,22.0908047 C24,20.1816094 24,17.2601719 24,12 C24,6.73982812 24,3.81839063 22.0908047,1.90919062 C20.1816094,0 17.2584375,0 12,0 C6.7415625,0 3.81839063,0 1.90919062,1.90919062 C0,3.81839063 0,6.7415625 0,12 C0,17.2584375 0,20.1816094 1.90919062,22.0908047 C3.81839063,24 6.7415625,24 12,24 Z" id="Path" fill="#000000"></path>
				<path d="M15.6930136,10 C14.8122694,10 14.1585599,10.706611 14.1585599,11.5784852 C14.1585599,12.2903739 14.6401831,12.8458269 15.2498975,13.0101908 L14,15 L15.1674409,15 L16.2300178,13.1481666 L17.0253678,13.1481666 L17.0253678,15 L18,15 L18,10 L15.6930136,10 Z M15.8270711,12.3022545 C15.4262194,12.3022545 15.178007,11.9753016 15.178007,11.6026488 C15.178007,11.2299959 15.4054971,10.8749272 15.8270711,10.8749272 L17.026643,10.8749272 L17.026643,12.3022545 L15.8270711,12.3022545 Z" id="Shape" fill="#FFFFFF"></path>
				<path d="M10.3553671,10 L10,10.9048283 L11.4581434,10.8970998 L10.5946051,13.8264536 C10.3483873,14.6806074 11.310893,15.3259315 12.1321775,14.8236759 L14,13.651592 L13.4500253,12.9039934 L11.5845044,14.0992858 L12.8419611,10 L10.3553671,10 Z" id="Path" fill="#FFFFFF"></path>
				<path d="M13.0000169,9 C13.5522766,9 14,8.77614541 14,8.5 C14,8.22387333 13.5522766,8 13.0000169,8 C12.4477234,8 12,8.22387333 12,8.5 C12,8.77614541 12.4477234,9 13.0000169,9 Z" id="Path" fill="#FFFFFF"></path>
				<path d="M9.25411729,13.8740741 L9.25411729,9 L5.13092488,9 L5.13092488,11.6013997 C5.13092488,12.8254337 4.72675236,13.5821845 4.48855192,13.8720264 L4,13.8720264 L4,15.9979523 L5.04561659,15.9979523 L5.04561659,14.7412 L8.95486041,14.7412 L8.95486041,16 L10,16 L10,13.8740741 L9.25411729,13.8740741 Z M6.17046596,11.5478305 L6.17046596,9.86468192 L8.18196425,9.86468192 L8.18196425,13.8712118 L5.58543382,13.8712118 C5.82084756,13.5335252 6.17046596,12.6741716 6.17046596,11.5478305 Z" id="Shape" fill="#FFFFFF"></path>
			</g>
		</g>
	</svg>
);



export const BlazonIcon: React.FC<IconSvgProps> = ({ fill, size, height, width, ...props }) => {
	return (
		<svg
			fill="none"
			height={size || height || 24}
			viewBox="0 0 23 38"
			width={size || width || 24}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M9.90056 36.3581C7.98547 34.9127 6.61241 32.7447 6.14272 30.2153H0V3.69335C3.28815 5.35554 5.67292 8.96893 5.92582 12.7268L6.86531 20.1702L6.39562 20.098C5.42002 20.098 4.55276 21.0375 4.55276 21.9407C4.55276 22.808 5.20324 23.5307 6.07039 23.7113L7.19055 23.9643C9.0333 20.4593 10.0812 17.0266 10.0812 13.6662C10.0812 10.631 9.68377 7.59586 9.61143 4.48839C9.61143 3.11532 10.1535 1.8506 10.9846 0.875C11.8518 1.8506 12.3577 3.11532 12.3577 4.48839C12.3577 7.59586 11.8879 10.631 11.8879 13.6662C11.8879 17.0266 12.9358 20.4593 14.7786 23.9643L15.8987 23.7113C16.7659 23.5307 17.4163 22.7719 17.4163 21.9407C17.4163 21.0014 16.5491 20.098 15.5735 20.098L15.176 20.1702L16.1155 12.7268C16.5852 8.96893 18.7532 5.31942 22.0413 3.69335V30.2153H15.8987C15.4289 32.7086 14.1282 34.9488 12.1408 36.3581C11.6711 36.6832 11.2736 37.0806 11.0207 37.6227C10.7677 37.0806 10.3702 36.6832 9.90056 36.3581ZM2.89069 21.0375C3.14359 20.0619 3.86629 19.1946 4.80577 18.6526L4.08307 12.51C3.83017 10.5949 3.03525 8.89659 1.84275 7.48741V21.0014H2.89069V21.0375ZM5.99816 28.3725C5.99816 27.4331 6.14272 26.6019 6.3234 25.7348L5.45614 25.5541C4.22764 25.1206 3.21592 24.1449 2.89069 22.8802H1.84275V28.3725H5.99816ZM10.0812 28.3725C10.0812 27.2524 9.21397 26.2768 8.09392 26.1323C7.91325 26.855 7.76869 27.5775 7.76869 28.3725H10.0812ZM10.0812 30.2153H8.02159C8.34682 31.6606 9.06952 32.9976 10.0812 34.1177V30.2153ZM13.008 24.4701C12.2131 23.0248 11.4904 21.5072 11.0207 19.9173C10.5509 21.5072 9.82833 23.0248 9.0333 24.4701C9.82833 24.6507 10.4787 25.1928 11.0207 25.807C11.5626 25.1928 12.2131 24.6507 13.008 24.4701ZM14.2365 28.3725C14.2365 27.5775 14.092 26.855 13.9114 26.1323C12.7912 26.2768 11.924 27.2524 11.924 28.3725H14.2365ZM13.9836 30.2153H11.924V34.1177C12.9358 32.9615 13.6584 31.6606 13.9836 30.2153ZM20.1986 28.3725V22.8802H19.1508C18.8255 24.1449 17.8138 25.1206 16.5852 25.518L15.718 25.6987C15.8987 26.5658 16.0433 27.3969 16.0433 28.3364H20.1986V28.3725ZM20.1986 21.0375V7.52353C19.0062 8.89659 18.1389 10.631 17.9583 12.5461L17.2357 18.6888C18.1752 19.2307 18.8977 20.0619 19.1508 21.0736H20.1986V21.0375Z"
				fill={fill} />
		</svg>
	);
};

{/* <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">

</svg> */}


export const BlazonWhiteIcon: React.FC<IconSvgProps> = ({ fill, size, height, width, ...props }) => {
	return (
		<svg
			fill="none"
			height={size || height || 60}
			viewBox="0 0 60 60"
			width={size || width || 60}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M5.48237 5.48398L5.48398 5.48237C7.6606 3.30077 10.4431 2.16536 14.3851 1.58639C18.361 1.00245 23.3894 1 29.9946 1C36.5996 1 41.6283 1.00243 45.6057 1.58509C49.549 2.16273 52.3347 3.29558 54.5168 5.47229C56.6991 7.6546 57.8346 10.4404 58.4136 14.3837C58.9976 18.361 59 23.3894 59 29.9946C59 36.5997 58.9976 41.6281 58.4136 45.6054C57.8346 49.5487 56.6991 52.3345 54.5168 54.5168C52.3347 56.699 49.5463 57.8346 45.6014 58.4136C41.6227 58.9976 36.5942 59 29.9946 59C23.3949 59 18.3664 58.9976 14.3891 58.4136C10.4455 57.8346 7.66045 56.6991 5.48398 54.5176L5.48317 54.5168C3.30102 52.3347 2.16542 49.5463 1.58641 45.6014C1.00244 41.6227 1 36.5942 1 29.9946C1 23.3949 1.00244 18.3664 1.5864 14.3891C2.16541 10.4455 3.30093 7.66045 5.48237 5.48398Z" stroke="white" strokeWidth="2" />
			<path d="M28.7069 49.2804C26.5517 47.6371 24.9623 45.1856 24.4504 42.33H17.5V12.2922C21.2446 14.1511 23.9116 18.2728 24.2349 22.5293L25.2856 30.9614L24.7737 30.8806C23.6422 30.8806 22.6724 31.9312 22.6724 32.9819C22.6724 33.9517 23.4267 34.7868 24.3966 35.0024L25.6627 35.2987C27.764 31.3386 28.9494 27.4593 28.9494 23.6338C28.9494 20.1856 28.4914 16.7642 28.4375 13.2621C28.4375 11.6996 29.0302 10.2718 30 9.16724C30.9698 10.2987 31.5625 11.6996 31.5625 13.2621C31.5625 16.7642 31.0506 20.2125 31.0506 23.6338C31.0506 27.4323 32.236 31.3386 34.3373 35.2987L35.6035 35.0024C36.5733 34.7868 37.3276 33.9517 37.3276 32.9819C37.3276 31.9312 36.3578 30.8806 35.2263 30.8806L34.7144 30.9614L35.7651 22.5293C36.2769 18.2728 38.7554 14.1511 42.5 12.2922V42.33H35.5496C35.0377 45.1586 33.5291 47.7179 31.2931 49.2804C30.7813 49.6575 30.3233 50.1155 30.0269 50.7082C29.6767 50.0886 29.2188 49.6575 28.7069 49.2804ZM20.7866 31.9582C21.083 30.8267 21.9181 29.8569 22.9418 29.2642L22.1067 22.3138C21.8103 20.1586 20.9213 18.219 19.5744 16.6295V31.9312H20.7866V31.9582ZM24.3157 40.2287C24.3157 39.178 24.4774 38.2082 24.6929 37.2384L23.7231 37.0228C22.2953 36.5649 21.1907 35.4603 20.8136 34.0325H19.6282V40.2287H24.3157ZM28.9224 40.2287C28.9224 38.9625 27.9526 37.831 26.6864 37.6963C26.4709 38.5045 26.3093 39.3397 26.3093 40.2287H28.9224ZM28.9224 42.33H26.6056C26.9828 43.9733 27.7909 45.455 28.9224 46.7481V42.33ZM32.2091 35.8375C31.32 34.1942 30.4849 32.47 29.9731 30.692C29.4612 32.497 28.6261 34.1942 27.7371 35.8375C28.6261 36.053 29.3804 36.6457 29.9731 37.3192C30.5657 36.6457 31.32 36.053 32.2091 35.8375ZM33.6369 40.2287C33.6369 39.3397 33.4752 38.5045 33.2597 37.6963C31.9935 37.858 31.0237 38.9625 31.0237 40.2287H33.6369ZM33.3405 42.33H31.0237V46.7481C32.1552 45.455 32.9634 43.9733 33.3405 42.33ZM40.3718 40.2287V34.0325H39.1864C38.8093 35.4603 37.7047 36.5649 36.2769 37.0228L35.3071 37.2384C35.5226 38.2082 35.6843 39.178 35.6843 40.2287H40.3718ZM40.3718 31.9582V16.6565C39.0248 18.219 38.055 20.1586 37.8394 22.3407L37.0043 29.2912C38.055 29.8838 38.8631 30.8537 39.1595 31.9851H40.3718V31.9582Z" fill="white" />
		</svg>
	);
};


export const SafetyIcon: React.FC<IconSvgProps> = ({ fill, size, height, width, ...props }) => {
	return (
		<svg
			fill={fill || "currentColor"}
			height={size || height || 24}
			viewBox="0 0 24 24"
			width={size || width || 24}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M680-280q25 0 42.5-17.5T740-340q0-25-17.5-42.5T680-400q-25 0-42.5 17.5T620-340q0 25 17.5 42.5T680-280Zm0 120q31 0 57-14.5t42-38.5q-22-13-47-20t-52-7q-27 0-52 7t-47 20q16 24 42 38.5t57 14.5ZM480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v227q-19-8-39-14.5t-41-9.5v-147l-240-90-240 90v188q0 47 12.5 94t35 89.5Q310-290 342-254t71 60q11 32 29 61t41 52q-1 0-1.5.5t-1.5.5Zm200 0q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80ZM480-494Z"
				fill={fill} />
		</svg>
	);
};

export const DarIcon: React.FC<IconSvgProps> = ({ fill, size, height, width, ...props }) => {
	return (
		<svg
			fill={fill || "currentColor"}
			height={size || height || 76}
			viewBox="0 0 75 76"
			width={size || width || 76}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="DAR" transform="translate(-0.0043, 0.0018)" fillRule="nonzero">
					<path d="M37.2435725,75.3368689 C34.8364725,75.3368689 32.4293725,75.3368689 30.0222725,75.3368689 C26.8127725,75.3130689 23.6268725,75.2179689 20.4409725,74.9324689 C17.6798725,74.6945689 14.9423725,74.2425689 12.2992725,73.3148689 C7.08383246,71.4593689 3.61475246,67.8434689 1.86841246,62.5623689 C1.01884246,59.9931689 0.64125546,57.3050689 0.38166446,54.6169689 C-0.0667195403,49.4310689 0.00407793468,44.2451689 0.00407793468,39.0592689 C0.00407793468,35.9904689 0.00407793468,32.9217689 0.00407793468,29.8530689 C0.0276770597,26.0468689 0.14567346,22.2406689 0.64125546,18.4582689 C0.99524346,15.6512689 1.63242246,12.9155689 2.88317246,10.3463689 C4.86551246,6.27851895 8.05139246,3.59040895 12.2284725,2.09172895 C14.6827725,1.21154895 17.2550725,0.735776947 19.8509725,0.521679947 C27.0487725,-0.0968243533 34.2464725,-0.0254585533 41.4678725,0.0459073467 C43.8749725,0.0696959467 46.2820725,0.0459073467 48.6891725,0.141061947 C52.5122725,0.307581947 56.3352725,0.474101947 60.0639725,1.40185895 C62.7778725,2.06793895 65.3029725,3.13842895 67.4976725,4.92256895 C70.1408725,7.06354895 71.8399725,9.82302895 72.8547725,13.0582689 C73.6806725,15.6512689 74.0818725,18.3393689 74.2942725,21.0512689 C74.8606725,28.5684689 74.6718725,36.1094689 74.6482725,43.6266689 C74.6482725,46.1482689 74.6482725,48.6698689 74.5066725,51.1914689 C74.3178725,54.5218689 74.0582725,57.8284689 73.2086725,61.0874689 C71.4387725,67.9147689 67.1673725,72.1729689 60.4179725,73.9333689 C58.2232725,74.5042689 55.9812725,74.7897689 53.7157725,74.9800689 C48.2643725,75.4320689 42.7657725,75.3606689 37.2435725,75.3368689 Z" id="Path" fill="#006666"></path>
					<path d="M9.27876246,45.4344689 C9.20796246,45.3630689 9.18436246,45.2441689 9.18436246,45.1489689 C9.16076246,45.0776689 9.16076246,45.0062689 9.16076246,44.9348689 C9.13716246,44.8635689 9.13716246,44.7921689 9.13716246,44.6969689 C9.11356246,43.9357689 8.78317246,43.3410689 8.19319246,42.9128689 C7.79201246,42.6035689 7.39082246,42.3181689 6.96604246,42.0326689 C6.89524246,41.9850689 6.82444246,41.8899689 6.82444246,41.7947689 C6.80084246,41.3903689 6.77724246,40.9859689 6.77724246,40.5815689 C6.77724246,40.5339689 6.77724246,40.4626689 6.87164246,40.4388689 C7.29642246,41.4855689 8.35839246,41.8185689 9.08996246,42.6511689 C9.08996246,42.5084689 9.11356246,42.4132689 9.11356246,42.3419689 C9.11356246,41.9375689 9.11356246,41.5331689 9.11356246,41.1049689 C9.08996246,40.6767689 8.97197246,40.2960689 8.71238246,39.9868689 C8.26399246,39.4159689 7.62681246,39.1066689 7.08403246,38.6784689 C6.94244246,38.5595689 6.73004246,38.4643689 6.70644246,38.2264689 C6.68285246,37.7507689 6.73004246,37.2749689 6.63565246,36.7991689 C6.63565246,36.7515689 6.61205246,36.7040689 6.68285246,36.6564689 C6.73004246,36.7278689 6.80084246,36.7991689 6.82444246,36.8943689 C7.03683246,37.4414689 7.41442246,37.8458689 7.86280246,38.2026689 C8.19319246,38.4643689 8.54718246,38.6784689 8.85397246,38.9639689 C8.92477246,39.0352689 8.97197246,39.1542689 9.11356246,39.1542689 C9.11356246,38.7022689 9.11356246,38.2740689 9.11356246,37.8220689 C9.11356246,37.2511689 8.92477246,36.7753689 8.54718246,36.3709689 C8.12240246,35.9189689 7.57961246,35.6335689 7.10763246,35.2766689 C6.80084246,35.0388689 6.54125246,34.8247689 6.61205246,34.3489689 C6.65925246,34.0872689 6.58845246,33.8255689 6.61205246,33.5639689 C6.61205246,33.4211689 6.58845246,33.2784689 6.65925246,33.1357689 C6.73004246,33.1357689 6.75364246,33.1832689 6.75364246,33.2308689 C6.91884246,33.7780689 7.22563246,34.2299689 7.65041246,34.5630689 C8.02800246,34.8722689 8.40559246,35.1577689 8.78317246,35.4432689 C8.90117246,35.5383689 8.97197246,35.6335689 9.06636246,35.7286689 C9.13716246,35.6573689 9.11356246,35.6097689 9.11356246,35.5383689 C9.11356246,35.1101689 9.11356246,34.6819689 9.11356246,34.2775689 C9.08996246,33.8731689 8.97197246,33.4687689 8.73597246,33.1595689 C8.31119246,32.6123689 7.74481246,32.3269689 7.22563246,31.9225689 C6.89524246,31.6846689 6.54125246,31.4705689 6.56485246,30.9233689 C6.58845246,30.4713689 6.56485246,29.9956689 6.56485246,29.5436689 C6.56485246,29.4960689 6.56485246,29.4246689 6.63565246,29.4009689 C6.63565246,29.4246689 6.65925246,29.4246689 6.65925246,29.4484689 C6.82444246,30.2097689 7.20203246,30.7806689 7.76841246,31.2326689 C8.12240246,31.5180689 8.47638246,31.7797689 8.83037246,32.0414689 C8.92477246,32.1128689 8.97197246,32.2555689 9.11356246,32.3269689 C9.11356246,32.2555689 9.13716246,32.1841689 9.13716246,32.1366689 C9.13716246,31.7797689 9.13716246,31.4229689 9.13716246,31.0423689 C9.16076246,30.2335689 8.80677246,29.6625689 8.21679246,29.2106689 C7.76841246,28.8537689 7.24923246,28.5683689 6.82444246,28.1876689 C6.68285246,28.0449689 6.54125246,27.9260689 6.54125246,27.6881689 C6.51765246,27.0458689 6.54125246,26.4273689 6.51765246,25.7850689 C6.47045246,24.7145689 6.47045246,23.6440689 6.44685246,22.5735689 C6.44685246,22.4308689 6.44685246,22.3119689 6.44685246,22.1691689 L6.42326246,22.1691689 C6.42326246,22.1929689 6.42326246,22.2405689 6.42326246,22.2643689 C6.42326246,23.3348689 6.39966246,24.4052689 6.39966246,25.4995689 C6.39966246,28.4969689 6.39966246,31.4943689 6.39966246,34.4916689 C6.39966246,35.9903689 6.42326246,37.5128689 6.42326246,39.0115689 C6.42326246,39.8678689 6.51765246,40.7242689 6.47045246,41.6044689 C6.44685246,42.4370689 6.56485246,43.2458689 6.94244246,43.9833689 C7.24923246,44.5780689 7.72121246,45.0300689 8.26399246,45.3392689 C8.90117246,45.6961689 9.06636246,46.2432689 9.06636246,46.9569689 C9.06636246,49.3833689 9.06636246,51.7859689 9.06636246,54.2124689 C9.06636246,54.2837689 9.06636246,54.3551689 9.13716246,54.4027689 L9.51475246,54.4027689 C9.51475246,54.3551689 9.53835246,54.3075689 9.53835246,54.2600689 C9.53835246,51.9287689 9.53835246,49.5974689 9.53835246,47.2899689 C9.53835246,47.0758689 9.53835246,46.8855689 9.56195246,46.6714689 C9.56195246,46.6238689 9.56195246,46.6000689 9.58554246,46.5524689 C9.46755246,46.2670689 9.39675246,45.9577689 9.34955246,45.6247689 C9.30235246,45.5057689 9.27876246,45.4820689 9.27876246,45.4344689 Z" id="Path" fill="#FFFFFF"></path>
					<path d="M9.30237246,29.4960689 C9.18437246,29.2106689 9.11358246,28.9727689 9.01918246,28.7824689 C8.85399246,28.4493689 8.66519246,28.1163689 8.52360246,27.7832689 C8.26401246,27.1410689 8.38200246,26.5224689 8.75959246,25.9753689 C9.08998246,25.4758689 9.25517246,24.9048689 9.25517246,24.2625689 C9.25517246,22.9066689 9.27877246,21.5744689 9.27877246,20.2185689 C9.27877246,20.1709689 9.27877246,20.1233689 9.32597246,20.0757689 C9.32597246,20.1471689 9.34957246,20.2423689 9.34957246,20.3136689 C9.34957246,21.2890689 9.37317246,22.2881689 9.34957246,23.2634689 C9.32597246,24.3577689 9.39677246,25.3806689 10.0103725,26.3321689 C10.3407725,26.8555689 10.2699725,27.4978689 9.93955246,28.0687689 C9.67996246,28.4969689 9.46756246,28.9251689 9.30237246,29.4960689 Z" id="Path" fill="#FFFFFF"></path>
					<path d="M12.3230725,25.4281689 C12.3230725,24.3576689 12.3230725,23.2871689 12.2994725,22.1929689 C12.2994725,22.1691689 12.2994725,22.1215689 12.2994725,22.0977689 L12.2758725,22.0977689 C12.2758725,22.2404689 12.2758725,22.3594689 12.2758725,22.5021689 C12.2522725,23.5726689 12.2758725,24.6431689 12.2050725,25.7136689 C12.1814725,26.3559689 12.2050725,26.9744689 12.1814725,27.6167689 C12.1814725,27.8546689 12.0398725,27.9973689 11.8982725,28.1162689 C11.4734725,28.5206689 10.9542725,28.7823689 10.5058725,29.1391689 C9.93953246,29.5911689 9.56195246,30.1620689 9.58555246,30.9709689 C9.58555246,31.3277689 9.58555246,31.6845689 9.58555246,32.0651689 C9.58555246,32.1127689 9.60915246,32.1841689 9.60915246,32.2554689 C9.75074246,32.2079689 9.79794246,32.0413689 9.89234246,31.9700689 C10.2463725,31.7083689 10.6002725,31.4466689 10.9542725,31.1612689 C11.5206725,30.7092689 11.9218725,30.1145689 12.0634725,29.3770689 C12.0634725,29.3532689 12.0870725,29.3532689 12.0870725,29.3294689 C12.1578725,29.3532689 12.1578725,29.4246689 12.1578725,29.4722689 C12.1578725,29.9242689 12.1342725,30.3999689 12.1578725,30.8519689 C12.1814725,31.3753689 11.8274725,31.5894689 11.4970725,31.8510689 C10.9778725,32.2554689 10.3878725,32.5409689 9.98673246,33.0880689 C9.72714246,33.4211689 9.60915246,33.8017689 9.60915246,34.2061689 C9.58555246,34.6343689 9.60915246,35.0625689 9.60915246,35.4669689 C9.60915246,35.5145689 9.58555246,35.5859689 9.65634246,35.6572689 C9.75074246,35.5621689 9.84514246,35.4431689 9.93953246,35.3718689 C10.3171725,35.0625689 10.6946725,34.8008689 11.0722725,34.4916689 C11.4970725,34.1347689 11.7802725,33.7066689 11.9690725,33.1594689 C11.9926725,33.1118689 11.9926725,33.0880689 12.0634725,33.0643689 C12.1342725,33.1832689 12.1106725,33.3497689 12.1106725,33.4925689 C12.1106725,33.7541689 12.0634725,34.0158689 12.1106725,34.2775689 C12.1814725,34.7533689 11.9218725,34.9911689 11.6150725,35.2052689 C11.1430725,35.5621689 10.6002725,35.8475689 10.1755725,36.2995689 C9.79794246,36.7039689 9.60915246,37.1797689 9.60915246,37.7506689 C9.60915246,38.1788689 9.60915246,38.6308689 9.60915246,39.0828689 C9.75074246,39.0828689 9.79794246,38.9638689 9.86874246,38.8925689 C10.1755725,38.5832689 10.5294725,38.3929689 10.8598725,38.1312689 C11.3082725,37.7744689 11.6858725,37.3938689 11.8982725,36.8229689 C11.9218725,36.7515689 11.9926725,36.6801689 12.0398725,36.5850689 C12.1106725,36.6326689 12.0870725,36.6801689 12.0870725,36.7277689 C12.0162725,37.2035689 12.0634725,37.6792689 12.0162725,38.1550689 C11.9926725,38.4167689 11.8038725,38.4881689 11.6386725,38.6070689 C11.0958725,39.0352689 10.4586725,39.3445689 10.0103725,39.9154689 C9.75074246,40.2484689 9.60915246,40.6290689 9.60915246,41.0334689 C9.60915246,41.4379689 9.60915246,41.8423689 9.60915246,42.2705689 C9.60915246,42.3418689 9.60915246,42.4370689 9.63274246,42.5797689 C10.3406725,41.7471689 11.4026725,41.4378689 11.8510725,40.3674689 C11.9690725,40.3912689 11.9454725,40.4625689 11.9454725,40.5101689 C11.9218725,40.9145689 11.9218725,41.3189689 11.8982725,41.7233689 C11.8982725,41.8423689 11.8510725,41.9136689 11.7566725,41.9612689 C11.3554725,42.2467689 10.9542725,42.5559689 10.5294725,42.8414689 C9.93953246,43.2696689 9.60914246,43.8643689 9.58555246,44.6255689 C9.58555246,44.8396689 9.53835246,45.0299689 9.49115246,45.2202689 C9.49115246,45.3868689 9.39675246,45.5533689 9.20796246,45.5533689 C9.20796246,45.5533689 9.20796246,45.5533689 9.18436246,45.5533689 C9.16076246,45.6960689 9.11356246,45.8625689 9.08996246,46.0053689 C9.13716246,46.1718689 9.16076246,46.3383689 9.18436246,46.5048689 C9.20796246,46.7189689 9.20796246,46.9092689 9.20796246,47.1233689 C9.20796246,49.4546689 9.20796246,51.7859689 9.20796246,54.0934689 C9.20796246,54.1410689 9.23156246,54.1885689 9.23156246,54.2361689 L9.60915246,54.2361689 C9.67994246,54.1885689 9.67994246,54.1172689 9.67994246,54.0458689 C9.67994246,51.6194689 9.67994246,49.2167689 9.67994246,46.7903689 C9.67994246,46.1004689 9.86874246,45.5295689 10.4822725,45.1727689 C11.0250725,44.8634689 11.4970725,44.4114689 11.8038725,43.8167689 C12.1814725,43.0793689 12.2994725,42.2705689 12.2758725,41.4378689 C12.2522725,40.5815689 12.3466725,39.7251689 12.3230725,38.8449689 C12.2994725,37.3462689 12.3466725,35.8237689 12.3466725,34.3251689 C12.3230725,31.4228689 12.3230725,28.4255689 12.3230725,25.4281689 Z" id="Path" fill="#FFFFFF"></path>
					<path d="M33.4442725,45.2441689 L33.4442725,51.6670689 L30.6359725,51.6670689 L30.6359725,47.9560689 L18.2936725,47.9560689 L18.2936725,51.6670689 L15.4145725,51.6670689 L15.4145725,45.2441689 L17.2552725,45.2441689 C17.6328725,43.7930689 17.7980725,41.5331689 17.7980725,38.1313689 L17.7980725,30.2811689 L31.3911725,30.2811689 L31.3911725,45.2441689 L33.4442725,45.2441689 Z M28.5120725,45.2917689 L28.5120725,32.9216689 L20.6771725,32.9216689 L20.6771725,38.1313689 C20.6771725,40.8194689 20.4411725,43.4362689 20.0871725,45.2917689 L28.5120725,45.2917689 Z" id="Shape" fill="#FFFFFF"></path>
					<path d="M47.6510725,43.8406689 L39.2733725,43.8406689 L37.7157725,47.9322689 L34.6714725,47.9322689 L41.7276725,30.2811689 L45.2675725,30.2811689 L52.3236725,47.9322689 L49.2321725,47.9322689 L47.6510725,43.8406689 Z M46.6362725,41.2476689 L43.4503725,32.9692689 L40.2644725,41.2476689 L46.6362725,41.2476689 L46.6362725,41.2476689 Z" id="Shape" fill="#FFFFFF"></path>
					<path d="M68.7958725,35.7048689 C68.7958725,39.1066689 66.3887725,41.1762689 62.5656725,41.1762689 L58.1289725,41.1762689 L58.1289725,47.9084689 L55.2262725,47.9084689 L55.2262725,30.2573689 L62.5656725,30.2573689 C66.4123725,30.2810689 68.7958725,32.3744689 68.7958725,35.7048689 Z M65.8459725,35.7524689 C65.8459725,33.8018689 64.5951725,32.8264689 62.2116725,32.8264689 L58.1525725,32.8264689 L58.1525725,38.6784689 L62.2116725,38.6784689 C64.5951725,38.6784689 65.8459725,37.6555689 65.8459725,35.7524689 Z" id="Shape" fill="#FFFFFF"></path>
				</g>
			</g>
		</svg>
	);
};

export const PersonIcon: React.FC<IconSvgProps> = ({
	size = 24,
	width,
	height,
	...props
}) => {
	return (
		<svg
			height={size || height}
			viewBox="0 -960 960 960"
			width={size || width}
			{...props}
		>
			<path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"/>
		</svg>
	);
};
